import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import * as actions from '../actions';
import SummaryView from '../view/SummaryView';

export class Summary extends React.Component {
	render() {
		const { error, errorDetail, project } = this.props;
		if (error) {
			return (
				<ErrorPage errorDetail={errorDetail} />
			);
		} else if (project) {
			return (
				<div className="summary">
					<SummaryView project={project} />
				</div>
			);
		}
		return <ContentLoading />;
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		project: state.project.project,
		error: state.project.error,
		errorDetail: state.project.errorDetail
	};
}

Summary.propTypes = {
	project: PropTypes.object,
	error: PropTypes.bool,
	errorDetail: PropTypes.object
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Summary);
